<template>
  <remote-modal
    ref="modal"
    :modal-title="modalTitle"
    @details-loaded="onFormLoaded"
  >
    <template #modal-content="{ modalState }">
      <template v-if="modalState.initialDataLoaded">
        <alert
          :message="errorMessage || undefined"
          :dismissable="true"
          @dismiss="errorMessage = null"
        />
        <div
          v-if="participantNameVisible"
          class="mb-2"
        >
          <label class="form-label">Participant</label>
          <input
            v-model="destination.participantName"
            type="text"
            class="form-control form-control-sm"
            readonly
          >
        </div>

        <template v-if="!ncpView">
          <div class="mb-2">
            <label class="form-label">Destination choice</label>
            <select
              ref="activitySelect"
              class="form-select"
            >
              <option />
            </select>
          </div>
          <div class="mb-2">
            <label class="form-label">Place</label>
            <select
              v-model="destination.activityPlaceId"
              class="form-select form-select-sm"
            >
              <option />
              <option
                v-for="place of destinationPlaces"
                :key="place.id"
                :value="place.id"
              >
                {{ place.title }}
              </option>
            </select>
          </div>
          <div
            v-if="showDestinationCountry"
            class="mb-2"
          >
            <label class="form-label">Host Country</label>
            <select
              v-model="destination.destinationChoiceCountryId"
              class="form-select form-select-sm"
            >
              <option :value="null" />
              <option
                v-for="country of countries"
                :key="country.id"
                :value="country.value"
              >
                {{ country.name }}
              </option>
            </select>
          </div>
          <div
            v-if="showHostingNcp"
            class="mb-2"
          >
            <label class="form-label">Hosting NCP</label>
            <input
              v-model="hostingNcpName"
              class="form-control form-control-sm"
              type="text"
              :disabled="true"
            >
          </div>
          <div class="row gx-2">
            <div
              v-if="exchangeTypes.length > 0"
              class="mb-2 col"
            >
              <label class="form-label">Type of exchange</label>
              <select
                v-model="destination.exchangeTypeId"
                class="form-select form-select-sm"
              >
                <option
                  v-for="(exchangeType, exchangeTypeIdx) of exchangeTypes"
                  :key="exchangeTypeIdx"
                  :value="exchangeType.value"
                  :disabled="exchangeType.id == 'separator'"
                >
                  {{ exchangeType.name }}
                </option>
              </select>
            </div>
            <div class="mb-2 col">
              <label class="form-label">Language</label>
              <select
                v-model="destination.languageId"
                class="form-select form-select-sm"
              >
                <option
                  v-for="(language, languageIdx) of languages"
                  :key="languageIdx"
                  :value="language.value"
                  :disabled="language.id == 'separator'"
                >
                  {{ language.name }}
                </option>
              </select>
            </div>
            <div class="mb-2 col">
              <label class="form-label">Length</label>
              <select
                v-model="destination.durationId"
                class="form-select form-select-sm"
              >
                <option
                  v-for="(duration, durationIdx) of durations"
                  :key="durationIdx"
                  :value="duration.value"
                  :disabled="duration.id == 'separator'"
                >
                  {{ duration.name }}
                </option>
              </select>
            </div>
          </div>
        </template>
        <div class="row gx-2">
          <div class="mb-2 col-12">
            <label class="form-label">Host institution/city</label>
            <input
              v-model="destination.hostInstitutionOrCity"
              type="text"
              class="form-control form-control-sm"
            >
          </div>
        </div>
        <div class="row gx-2">
          <div class="mb-2 col">
            <label class="form-label">Start date</label>
            <date-picker
              v-model="startDateValue"
              :show-time="false"
              :small="true"
              data-date-ref="st-start-date"
            />
          </div>
          <div class="mb-2 col">
            <label class="form-label">End date</label>
            <date-picker
              v-model="endDateValue"
              :show-time="false"
              :small="true"
              data-date-sync-ref="st-start-date"
            />
          </div>
        </div>
        <div class="row gx-2">
          <div class="mb-2 col">
            <label for="tutor_name" class="form-label">Tutor name</label>
            <input
              id="tutor_name"
              v-model="destination.tutorName"
              type="text"
              class="form-control form-control-sm"
            >
          </div>
          <div class="mb-2 col">
            <label class="form-label">Tutor e-mail</label>
            <input
              v-model="destination.tutorEmail"
              type="text"
              class="form-control form-control-sm"
            >
          </div>
        </div>
        <div class="row gx-2">
          <div class="mb-2 col">
            <label for="tutor_name" class="form-label">Tutor phone</label>
            <input
              id="tutor_phone"
              v-model="destination.tutorPhone"
              type="text"
              class="form-control form-control-sm"
            >
          </div>
        </div>
        <div
          v-if="isCP != true"
          class="mb-2"
        >
          <label class="form-label">Group name</label>
          <input
            v-model="destination.groupName"
            type="text"
            class="form-control form-control-sm"
          >
        </div>
        <div
          v-if="showNotes"
          class="mb-2"
        >
          <label class="form-label">Notes</label>
          <textarea
            v-model="destination.notes"
            rows="4"
            class="form-control form-control-sm"
          />
        </div>
      </template>
    </template>
    <template #modal-footer="{ modalState }">
      <button
        type="button"
        class="btn btn-sm btn-secondary"
        data-bs-dismiss="modal"
      >
        Close
      </button>
      <button
        type="button"
        class="btn btn-sm btn-primary"
        :disabled="approveBtnDisabled(modalState)"
        @click.prevent="approveParticipant"
      >
        {{ editMode ? 'Update' : 'Approve' }}
      </button>
    </template>
  </remote-modal>
</template>
<script setup lang="ts">
import { computed, nextTick, ref, useTemplateRef } from 'vue'
import $ from 'jquery'
import axios from 'axios'
import Rails from '@rails/ujs'
import Jsona from 'jsona'
import RemoteModal from '../remote-modal.vue'
import DatePicker from '../date-picker.vue'
import Alert from '../alert.vue'
import type { DataFormat, GroupedDataFormat } from 'select2'
import type { GridID } from '../types'
import { getAxiosError } from '@/js/axios-utils'
import { isNonEmptyString } from '@/js/js-utils'
import { OspeActivityType } from '@/js/ospe-types'

interface IdNameItem {
  id: string;
  value: number | string;
  name: string;
}

interface ShortTermDestinationPlace {
  id: number;
  title: string;
  hostingNcpName?: string;
  allowPreMatchedParticipantToBeNamed: boolean;

  exchangeTypes: IdNameItem[];
  languages: IdNameItem[];
  durations: IdNameItem[];
}

interface ShortTermDestinationActivity {
  // id is a specially crafted string, not and actual activityId
  id: string;
  activityId: number;
  title: string;
  countryId: number | null;
  countryName: string;
  number?: string;

  places: ShortTermDestinationPlace[];

  defaultPlaceId: number | null;
  defaultExchangeTypeId: number | null;
  defaultLanguageId: number | null;
  defaultDurationId: number | null;
}

interface ShortTermDestination {
  id: string;
  activityTypeId: number;
  ncpView: boolean; // maybe this belongs to jsonapi meta field

  participantName?: string | null;

  currentChoicePlaces: ShortTermDestinationActivity[];
  firstChoicePlaces: ShortTermDestinationActivity[];
  secondChoicePlaces: ShortTermDestinationActivity[];
  thirdChoicePlaces: ShortTermDestinationActivity[];

  activities: ShortTermDestinationActivity[];

  initialActivityValue: string;
  selectedExchangeTypeId: number | null;
  selectedLanguageId: number | null;
  selectedDurationId: number | null;
  selectedDestinationChoiceCountryId: number | null;

  hostInstitutionOrCity: string | null;
  startDate: string | null;
  endDate: string | null;
  tutorName: string | null;
  tutorEmail: string | null;
  tutorPhone: string | null;
  groupName: string | null;
  notes: string | null;

  exchangeTypes: IdNameItem[];
  languages: IdNameItem[];
  durations: IdNameItem[];
  countries: IdNameItem[];

  meta?: {
    showNotes: boolean;
  };
}

interface Destination {
  participantName: string | null;
  activityId: number | null;
  activityPlaceId: number | null;
  countryId: number | null;
  destinationChoiceCountryId: number | null;
  exchangeTypeId: number | null;
  languageId: number | null;
  durationId: number | null;
  hostInstitutionOrCity: string | null;
  startDate: string | null;
  endDate: string | null;
  tutorName: string | null;
  tutorEmail: string | null;
  tutorPhone: string | null;
  groupName: string | null;
  notes: string | null;
}

interface ChoicesGroupChild extends DataFormat {
  activity?: ShortTermDestinationActivity;
}

interface ChoicesGroup extends GroupedDataFormat {
  children: ChoicesGroupChild[];
}

interface ModalState {
  initialDataLoaded: boolean;
  isLoading: boolean;
}

const emit = defineEmits<{
  "success": []
}>()

const modal = useTemplateRef<InstanceType<typeof RemoteModal>>("modal")
const activitySelect = useTemplateRef<HTMLSelectElement>("activitySelect")

const buildDestination = (): Destination => ({
  participantName: null,
  activityId: null,
  activityPlaceId: null,
  countryId: null,
  destinationChoiceCountryId: null,
  exchangeTypeId: null,
  languageId: null,
  durationId: null,
  hostInstitutionOrCity: null,
  startDate: null,
  endDate: null,
  tutorName: null,
  tutorEmail: null,
  tutorPhone: null,
  groupName: null,
  notes: null,
})

const createChoiceGroup = (title: string, activities: ShortTermDestinationActivity[]): ChoicesGroup => {
  const group: ChoicesGroup = {
    text: title,
    children: [],
  }
  activities.forEach((activity) => {
    group.children.push({
      id: activity.id,
      text: activity.title,
      activity: JSON.parse(JSON.stringify(activity)),
    })
  })

  return group
}

const ncpView = ref<boolean>(false)
const destination = ref<Destination>(buildDestination())
const availableActivities = ref<ChoicesGroup[]>([])

// when activity is selected from destination dropdown
const destinationActivity = ref<ShortTermDestinationActivity | null>(null)

const submitUrl = ref<string | null>(null)
const errorMessage = ref<string | null>(null)
const editMode = ref<boolean>(false)
const activityType = ref<OspeActivityType | null>(null)

const allExchangeTypes = ref<IdNameItem[]>([])
const allLanguages = ref<IdNameItem[]>([])
const allDurations = ref<IdNameItem[]>([])
const countries = ref<IdNameItem[]>([])

const showNotes = ref<boolean>(false)

const modalTitle = computed((): string => {
  switch (activityType.value) {
    case OspeActivityType.cp:
      return 'Destination select (President-Chief PR)'
    case OspeActivityType.ge:
      return 'Destination select (General exchange)'
    case OspeActivityType.se:
      return 'Destination select (Specialised exchange)'
    case OspeActivityType.cepol:
      return 'Destination select (CEPOL-EJTN exchange)'
    case OspeActivityType.cs:
      return 'Destination select (Court staff)'
    case OspeActivityType.et:
      if (destinationActivity.value) {
        return `Destination select (${destinationActivity.value.number})`
      }
      return 'Destination select (Exchanges)'
  }
  return 'Destination select (Short Term)'
})

const isCP = computed((): boolean => {
  return activityType.value == OspeActivityType.cp
})

const destinationActivityPlace = computed((): ShortTermDestinationPlace | null => {
  if (destinationActivity.value && destination.value.activityPlaceId) {
    for (const place of destinationActivity.value.places) {
      if (place.id == destination.value.activityPlaceId) {
        return place
      }
    }
  }
  return null
})

const exchangeTypes = computed((): IdNameItem[] => {
  const result = [] as IdNameItem[]

  if (destinationActivityPlace.value) {
    destinationActivityPlace.value.exchangeTypes.forEach(exchangeType => result.push(exchangeType))
  }

  if (allExchangeTypes.value.length > 0) {
    if (result.length > 0) {
      result.push({
        id: 'separator',
        value: 'separator',
        name: '──────────',
      })
    }
    allExchangeTypes.value.forEach(exchangeType => result.push(exchangeType))
  }
  return result
})

const languages = computed((): IdNameItem[] => {
  const result = [] as IdNameItem[]

  if (destinationActivityPlace.value) {
    destinationActivityPlace.value.languages.forEach(language => result.push(language))
  }

  if (allLanguages.value.length > 0) {
    if (result.length > 0) {
      result.push({
        id: 'separator',
        value: 'separator',
        name: '──────────',
      })
    }
    allLanguages.value.forEach(language => result.push(language))
  }
  return result
})

const durations = computed((): IdNameItem[] => {
  const result = [] as IdNameItem[]
  if (destinationActivityPlace.value) {
    destinationActivityPlace.value.durations.forEach(duration => result.push(duration))
  }

  if (allDurations.value.length > 0) {
    if (result.length > 0) {
      result.push({
        id: 'separator',
        value: 'separator',
        name: '──────────',
      })
    }
    allDurations.value.forEach(duration => result.push(duration))
  }
  return result
})

const startDateValue = computed({
  get(): any {
    return {
      date: destination.value.startDate || '',
      time: null
    }
  },
  set(value: any): void {
    if (value && isNonEmptyString(value.date)) {
      destination.value.startDate = value.date
    } else {
      destination.value.startDate = null
    }
  }
})

const endDateValue = computed({
  get(): any {
    return {
      date: destination.value.endDate || '',
      time: null
    }
  },
  set(value: any): void {
    if (value && isNonEmptyString(value.date)) {
      destination.value.endDate = value.date
    } else {
      destination.value.endDate = null
    }
  }
})

const destinationPlaces = computed((): ShortTermDestinationPlace[] => {
  if (destinationActivity.value) {
    return destinationActivity.value.places
  }
  return []
})

const participantNameVisible = computed((): boolean => {
  return isNonEmptyString(destination.value.participantName)
})

const hostingNcpName = computed((): string => {
  return destinationActivityPlace.value?.hostingNcpName || ''
})

const showHostingNcp = computed((): boolean => {
  return activityType.value == OspeActivityType.et
})

const showDestinationCountry = computed((): boolean => {
  return destinationActivityPlace.value?.allowPreMatchedParticipantToBeNamed == true
})

const show = (url: string, applicationIds: GridID[] | null, isEditMode?: boolean): void => {
  editMode.value = isEditMode == true
  showNotes.value = false
  if (Array.isArray(applicationIds)) {
    modal.value?.showModal(url, {
      application_ids: applicationIds.join(',')
    })
  } else {
    modal.value?.showModal(url, {}, {
      headers: {
        'Accept': 'application/json',
      },
    })
  }
}

const hide = (): void => {
  modal.value?.hideModal()
}

const loadDataForActivity = (activity: ShortTermDestinationActivity): void => {
  destinationActivity.value = activity
  destination.value.activityId = activity.activityId
  destination.value.countryId = activity.countryId
  destination.value.activityPlaceId = activity.defaultPlaceId ?? null
  destination.value.exchangeTypeId = activity.defaultExchangeTypeId ?? null
  destination.value.languageId = activity.defaultLanguageId ?? null
  destination.value.durationId = activity.defaultDurationId ?? null
}

const initFields = (initialActivityValue: string | null): void => {
  const activitySelectEl = activitySelect.value
  if (activitySelectEl) {
    const data = [] as GroupedDataFormat[]

    availableActivities.value.forEach((choice) => {
      data.push(choice)
    })

    // clear selection box, otherwise previously populated items
    // are still preserved
    activitySelectEl.innerHTML = ''
    activitySelectEl.options.add(new Option('')) // required for placeholder to work

    $(activitySelectEl).select2({
      placeholder: 'Select destination choice',
      allowClear: true,
      data: data as any as GroupedDataFormat[],
    })

    if (initialActivityValue) {
      $(activitySelectEl).val(initialActivityValue)
      $(activitySelectEl).trigger('change')

      const selectedItems = $(activitySelectEl).select2('data')
      if (selectedItems.length > 0) {
        const item = selectedItems[0]
        if ((item as any).activity) {
          const activity = JSON.parse(JSON.stringify((item as any).activity))
          loadDataForActivity(activity)
        }
      }
    }

    $(activitySelectEl).off('.shortTermDestination')
    $(activitySelectEl).on('select2:clear.shortTermDestination', () => {
      destinationActivity.value = null
      destination.value.activityId = null
      destination.value.activityPlaceId = null
      destination.value.countryId = null
    })
    $(activitySelectEl).on('select2:select.shortTermDestination', (e: any) => {
      const result = e.params.data as ChoicesGroupChild

      destinationActivity.value = null
      if (result.activity) {
        const activity = JSON.parse(JSON.stringify(result.activity))
        loadDataForActivity(activity)
      }
    })
  }
}

const onFormLoaded = (data: any): void => {
  destination.value = buildDestination()
  destinationActivity.value = null
  errorMessage.value = null
  availableActivities.value = []
  ncpView.value = false

  const result = new Jsona().deserialize(data) as ShortTermDestination
  ncpView.value = result.ncpView
  activityType.value = result.activityTypeId
  destination.value.participantName = isNonEmptyString(result.participantName) ? result.participantName : null
  if (result.selectedExchangeTypeId) {
    destination.value.exchangeTypeId = result.selectedExchangeTypeId
  }
  if (result.selectedLanguageId) {
    destination.value.languageId = result.selectedLanguageId
  }
  if (result.selectedDurationId) {
    destination.value.durationId = result.selectedDurationId
  }
  destination.value.destinationChoiceCountryId = result.selectedDestinationChoiceCountryId ?? null

  destination.value.hostInstitutionOrCity = result.hostInstitutionOrCity || null
  destination.value.startDate = result.startDate || null
  destination.value.endDate = result.endDate || null
  destination.value.tutorName = result.tutorName || null
  destination.value.tutorEmail = result.tutorEmail || null
  destination.value.tutorPhone = result.tutorPhone || null
  destination.value.groupName = result.groupName || null
  destination.value.notes = result.notes || null

  showNotes.value = result.meta?.showNotes == true

  if (Array.isArray(result.currentChoicePlaces) && result.currentChoicePlaces.length > 0) {
    availableActivities.value.push(createChoiceGroup('Current destination', result.currentChoicePlaces))
  }

  if (Array.isArray(result.firstChoicePlaces) && result.firstChoicePlaces.length > 0) {
    availableActivities.value.push(createChoiceGroup('First choice', result.firstChoicePlaces))
  }

  if (Array.isArray(result.secondChoicePlaces) && result.secondChoicePlaces.length > 0) {
    availableActivities.value.push(createChoiceGroup('Second choice', result.secondChoicePlaces))
  }

  if (Array.isArray(result.thirdChoicePlaces) && result.thirdChoicePlaces.length > 0) {
    availableActivities.value.push(createChoiceGroup('Third choice', result.thirdChoicePlaces))
  }

  if (Array.isArray(result.exchangeTypes)) {
    allExchangeTypes.value = result.exchangeTypes
  } else {
    allExchangeTypes.value = []
  }

  if (Array.isArray(result.languages)) {
    allLanguages.value = result.languages
  } else {
    allLanguages.value = []
  }

  if (Array.isArray(result.durations)) {
    allDurations.value = result.durations
  } else {
    allDurations.value = []
  }

  if (Array.isArray(result.countries)) {
    countries.value = result.countries
  } else {
    countries.value = []
  }

  if (Array.isArray(result.activities) && result.activities.length > 0) {
    const otherActivities = [] as ChoicesGroupChild[]
    result.activities.forEach((activity) => {
      otherActivities.push({
        id: activity.id,
        text: activity.title,
        activity: JSON.parse(JSON.stringify(activity)),
      })
    })
    availableActivities.value.push({
      text: 'Other activities',
      children: otherActivities,
    })
  }

  if (isNonEmptyString(data?.links?.submit)) {
    submitUrl.value = data.links.submit
  } else {
    submitUrl.value = null
  }

  nextTick(() => {
    initFields(result.initialActivityValue)
  })
}

const approveBtnDisabled = (modalState: ModalState): boolean => {
  if (!modalState.initialDataLoaded || modalState.isLoading) {
    return true
  }
  return !isNonEmptyString(submitUrl.value)
}

const approveParticipant = (): void => {
  errorMessage.value = null

  if (isNonEmptyString(submitUrl.value)) {
    modal.value?.showLoadingIndicator(true)

    const choiceParams: any = {
      host_institution_or_city: destination.value.hostInstitutionOrCity,
      start_date: destination.value.startDate,
      end_date: destination.value.endDate,
      tutor_name: destination.value.tutorName,
      tutor_email: destination.value.tutorEmail,
      tutor_phone: destination.value.tutorPhone,
      group_name: destination.value.groupName,
      notes: destination.value.notes
    }

    if (!ncpView.value) {
      choiceParams.country_id = destination.value.countryId
      choiceParams.activity_place_id = destination.value.activityPlaceId
      choiceParams.exchange_type_id = destination.value.exchangeTypeId
      choiceParams.language_id = destination.value.languageId
      choiceParams.duration_id = destination.value.durationId
      choiceParams.destination_choice_country_id = showDestinationCountry.value ? destination.value.destinationChoiceCountryId : null
    }

    axios.post(submitUrl.value, {
      destination_choice: choiceParams
    }, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': Rails.csrfToken()
      },
    })
      .then(() => {
        emit('success')
      })
      .catch((error) => {
        errorMessage.value = getAxiosError(error) || 'An error occured'
      })
      .then(() => {
        modal.value?.showLoadingIndicator(false)
      })
  }
}

defineExpose({
  hide,
  show,
})
</script>
